/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-controls-skip-back-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.875 17.5a.623.623 0 01-.313-.084L4.687 10.54a.625.625 0 010-1.082l11.875-6.875a.625.625 0 01.938.541v13.75c0 .345-.28.625-.625.625zM1.25 2.5H2.5v15H1.25v-15z"/>'
  }
})
